// src/regl/ReglFramebuffer.ts
var ReglFramebuffer = class {
  constructor(reGl, options) {
    const { width, height, color, colors } = options;
    const framebufferOptions = {
      width,
      height
    };
    if (Array.isArray(colors)) {
      framebufferOptions.colors = colors.map(
        (c) => c.get()
      );
    }
    if (color && typeof color !== "boolean") {
      framebufferOptions.color = color.get();
    }
    this.framebuffer = reGl.framebuffer(framebufferOptions);
  }
  get() {
    return this.framebuffer;
  }
  destroy() {
    this.framebuffer.destroy();
  }
  resize({ width, height }) {
    this.framebuffer.resize(width, height);
  }
};
export {
  ReglFramebuffer as default
};
